import { Component } from '@angular/core';

@Component({
  selector: 'what3words-logo',
  templateUrl: './what3words.component.html',
  standalone: true,
  styleUrls: ['./what3words.component.scss'],
})
export class What3wordsComponent {}
